import { AppState } from '../reducers'

export const getCoupons = (state: AppState) => state.coupons
